import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash } from "react-icons/fa";
import DatePicker from "react-datepicker";
import axios from 'axios';
import { addOccasionPrintLabel, getOccasionDataPrintLabel, deleteOccasionPrintData, updateOccasionPrintLabel } from "../../server/Api";

import "react-datepicker/dist/react-datepicker.css";

const OccasionPrintLabel = () => {
    // States to manage form inputs
    const [address, setAddress] = useState('');
    const [occasionName, setOccasionName] = useState('');
    const [extensionName, setExtensionName] = useState('');
    const [fontFamily, setFontFamily] = useState('');
    const [fontColor, setFontColor] = useState('');
    const [labelType, setLabelType] = useState('');
    const [selectedLookupId, setSelectedLookupId] = useState(null);

    // State to manage the saved events
    const [occasions, setOccasions] = useState([]);
    const [filteredOccasions, setFilteredOccasions] = useState([]); // Filtered data
    // State for success or error message
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');  // 'success' or 'error'

    // State for showing confirmation dialog for delete
    const [deleteConfirmation, setDeleteConfirmation] = useState({
        isOpen: false,
        eventOccasionPrintId: null,
        eventOccasion: ''
    });
    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    useEffect(() => {
        fetchOccasions();
    }, []); // Only runs on mount


    const fetchOccasions = () => {
        if (getOccasionDataPrintLabel) {
            axios
                .get(getOccasionDataPrintLabel())
                .then((response) => {
                    setOccasions(response.data.data); // Update state with fresh data
                    setFilteredOccasions(response.data.data); // Update state with fresh data
                })
                .catch((error) => {
                    console.error('Error fetching Occasion Print Label values:', error);
                });
        }
    };

    // Handle form submit
    const handleSaveOccasion = async () => {
        // Data to be sent to the backend API
        const newUserData = {
            address: address,
            eventOccasion: occasionName,
            extensionName: extensionName,
            fontFamily: fontFamily,
            fontColor: fontColor,
            labelType: labelType,
            enteredBy: 'User'
        };
        console.log(newUserData);
        try {
            // Send data to the backend
            let response;
            if (isEditing) {
                response = await axios.put(`${updateOccasionPrintLabel()}/${editId}`, newUserData);
            } else {
                // await axios.post('/api/data', formData);
                response = await axios.post(addOccasionPrintLabel(), newUserData);
            }
            

            // Check response and handle the message accordingly
            if (response.status === 201) {
                setMessage('Occasion saved successfully!');
                setMessageType('success');

                // Add the new occasion to the table (state update)
                setOccasions(prevOccasions => [
                    ...prevOccasions,
                    {
                        ...newUserData,
                    }
                ]);
                setFilteredOccasions(prevOccasions => [
                    ...prevOccasions,
                    {
                        ...newUserData,
                    }
                ]); // Set filtered data initially
                // Clear form fields after successful submission
                setOccasionName('');
                setExtensionName('');
                setAddress('');
                setFontFamily('');
                setFontColor('');
                setLabelType('');
                setIsEditing(false);
                setEditId(null);
                fetchOccasions();
            } else {
                throw new Error('Failed to save occasion');
            }
        } catch (error) {
            setMessage('Error during occasion saving: ' + error.message);
            setMessageType('error');
        }
    };

    // Cancel delete action
    const cancelForm = () => {
        setOccasionName('');
        setExtensionName('');
        setAddress('');
        setFontFamily('');
        setFontColor('');
        setLabelType('');
    };

    // Handle edit button click
    const handleEdit = (value) => {
        setOccasionName(value.eventOccasion);
        setExtensionName(value.extensionName);
        setAddress(value.address);
        setFontFamily(value.fontFamily);
        setFontColor(value.fontColor);
        setLabelType(value.labelType);
        setIsEditing(true);
        setEditId(value.eventOccasionPrintId);
    };

    // Handle delete button click
    const handleDelete = (value) => {
        setDeleteConfirmation({
            isOpen: true,
            eventOccasionPrintId: value.eventOccasionPrintId,
            eventOccasion: value.eventOccasion
        });
    };


    // Confirm delete action
    const confirmDelete = async () => {
        try {
            await axios.delete(`${deleteOccasionPrintData()}/${deleteConfirmation.eventOccasionPrintId}`);
            setOccasions(occasions.filter(value => value.eventOccasionPrintId !== deleteConfirmation.eventOccasionPrintId));

            // Close the confirmation modal
            setDeleteConfirmation({ isOpen: false, eventOccasionPrintId: null, eventOccasion: '' });
        } catch (error) {
            console.error('Error deleting Occasion Print Label :', error);
        }
    };

    // Cancel delete action
    const cancelDelete = () => {
        setDeleteConfirmation({ isOpen: false, eventOccasionPrintId: null, eventOccasion: '' });
    };

    // Handle the search input change
    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        // Filter occasions based on search query
        const filteredData = occasions.filter((occasion) => {
            return (
                occasion.eventOccasion?.toLowerCase().includes(query) ||
                occasion.extensionName?.toLowerCase().includes(query) ||
                occasion.address?.toLowerCase().includes(query) ||
                occasion.labelType?.toLowerCase().includes(query) ||
                occasion.fontFamily?.toLowerCase().includes(query) ||
                occasion.fontColor?.toLowerCase().includes(query)
            );
        });
        setFilteredOccasions(filteredData);
    };
    
    const [searchTerm, setSearchTerm] = useState("");

    return (
        <div className='container-fluid'>
            <div className="row mb-20">
                <div class="occasion-top d-flex justify-content-between  align-items-center">
                    <h2>Occasion Print Label</h2>
                    <div style={{ maxWidth: '300px', width: '100%' }}>
                        <input type="text" className="form-control mb-3"  placeholder="Search occasions..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-lg-12'>
                    <div className="form-section">
                        <form>
                            <div className='row'>
                                {/* Occasion Name Field */}
                                <div className='col-xl-6 mb-3'>
                                    <label className="form-label">Event Occasion</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="occasionName"
                                            placeholder="Occasion Name"
                                            value={occasionName}
                                            onChange={(e) => setOccasionName(e.target.value)}
                                        />
                                </div>

                                {/* Hosted By Field */}
                                <div className='col-xl-6 mb-3'>
                                    <label className="form-label" htmlFor="capacity">Name Suffix</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="capacity"
                                            placeholder="Hosted by"
                                            value={extensionName}
                                            onChange={(e) => setExtensionName(e.target.value)}
                                        />
                                </div>

                                {/* Email Field */}
                                <div className='col-xl-6 mb-3'>
                                    <label className="form-label" htmlFor="dress-code">Address</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="address"
                                            placeholder="address"
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                        />
                                </div>

                                {/* Password Field */}
                                <div className='col-xl-6 mb-3'>
                                    <label className="form-label" htmlFor="label-type">Invitation Type <span >*</span></label>
                                        <input
                                            type="text"
                                            className="form-control custom-form-control"
                                            id="label-type"
                                            placeholder="Label Type"
                                            value={labelType}
                                            onChange={(e) => setLabelType(e.target.value)}
                                        />
                                </div>

                                {/* Font family */}
                                <div className='col-xl-6 mb-3'>
                                    <label className="form-label" htmlFor="font-family">Font family</label>
                                        <input
                                            type="text"
                                            className="form-control custom-form-control"
                                            id="font-family"
                                            placeholder="Font family"
                                            value={fontFamily}
                                            onChange={(e) => setFontFamily(e.target.value)}
                                        />
                                </div>

                                {/* Font Color */}
                                <div className='col-xl-6 mb-3'>
                                    <label className="form-label" htmlFor="font-color">Font color</label>
                                        <input
                                            type="text"
                                            className="form-control custom-form-control"
                                            id="font-color"
                                            placeholder="Font color"
                                            value={fontColor}
                                            onChange={(e) => setFontColor(e.target.value)}
                                        />
                                </div>

                            </div>
                            <div className="d-flex justify-content-end gap-2 justify-content-center py-3">
                                <button
                                    className='btn btn-primary mr-30 btn-save'
                                    onClick={handleSaveOccasion}  // Handle save occasion
                                >
                                    Save
                                </button>
                                <button className='btn btn-secondary btn-cancel' onClick={cancelForm}>Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* Success/Error Message */}
            {message && (
                <div className={`alert alert-${messageType === 'success' ? 'success' : 'danger'} mt-3`}>
                    {message}
                </div>
            )}

            {/* Buttons */}
            {/* <div className='row mt-20'>
                <div className='col-xl-8'>
                    <button
                        className='btn btn-primary mr-30'
                        onClick={handleSaveOccasion}  // Handle save occasion
                    >
                        Save
                    </button>
                    <button className='btn btn-secondary' onClick={cancelForm}>Cancel</button>
                </div>
            </div> */}

            {/* Occasions Table */}
            <div className="form-section mt-30">
                <div className='row'>
                    <div className='col-xl-8'>
                    {/* Search Box */}
                    <input
                        type="text"
                        placeholder="Search by name..."
                        value={searchQuery}
                        onChange={handleSearch}
                        style={{ marginBottom: '20px', padding: '10px', width: '300px' }}
                    />
                    </div>
                    
                    <div className='col-xl-12'>
                        <div className='table-responsive'>
                            <table className='table table-striped table-hover '>
                                <thead className='table-dark table-bg-new'>
                                    <tr>
                                        <th>Sr.No.</th>
                                        <th>Event Occasion</th>
                                        <th>Suffix</th>
                                        <th>Address</th>
                                        <th>label Type</th>
                                        <th>Font Family</th>
                                        <th>Font Color</th>
                                        <th colSpan={"2"}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredOccasions.length > 0 ? (filteredOccasions.map((value, index) => (
                                                <tr key={value.eventOccasionPrintId}>
                                                    <td>{index + 1}</td>
                                                    <td>{value.eventOccasion}</td>
                                                    <td>{value.extensionName}</td>
                                                    <td>{value.address}</td>
                                                    <td>{value.labelType}</td>
                                                    <td>{value.fontFamily}</td>
                                                    <td>{value.fontColor}</td>
                                                    <td><a href="#" class="btn edit-btn" onClick={() => handleEdit(value)}>Edit</a></td>
                                                    <td><a href="#" class="btn btn-danger" onClick={() => handleDelete(value)}>Delete</a> </td>
                                                </tr>
                                            ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6">No Occasion Print Label values found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {deleteConfirmation.isOpen && (
                <div className="alert alert-warning mt-20">
                    <div>Are you sure you want to delete "{deleteConfirmation.eventOccasion}"?</div>
                    <button className="btn btn-danger" onClick={confirmDelete}>Yes</button>
                    <button className="btn btn-secondary" onClick={cancelDelete}>No</button>
                </div>
            )}
        </div>
    );
};

export default OccasionPrintLabel;
